import ContestFeature from "./../features/Contests";

export default function Contests() {
  return <ContestFeature />;
}
